export const validarQtdeCaractere = (texto, min, max) => {
  return typeof texto === 'string' && texto.length >= min && texto.length <= max;
};

export const calcularNota = itens => {
  let total = itens.length;
  let aprovados = itens.filter(i => i).length;
  return aprovados / total;
};

function normalizarTexto(texto) {
  return texto
    .toLowerCase() // tudo minúsculo
    .normalize('NFD') // remove acentos
    .replace(/[\u0300-\u036f]/g, '') // remove marcas de acento
    .replace(/[^a-z0-9]/g, ''); // remove tudo que não for letra ou número
}

export const estaContido = (textoPequeno, textoMaior) => {
  const pequenoNormalizado = normalizarTexto(textoPequeno);
  const maiorNormalizado = normalizarTexto(textoMaior);

  return maiorNormalizado.includes(pequenoNormalizado);
};

export const validarPermalink = (permalink, slug) => {
  try {
    const url = new URL(permalink);
    return permalink === `${url.origin}/${slug}/`;
  } catch {
    return false;
  }
};

export const validarUrlOpcional = permalink => {
  try {
    if (!permalink) return false;
    const url = new URL(permalink);
    return permalink.includes(url.hostname) && permalink.startsWith('https');
  } catch {
    return false;
  }
};
